import { UIGameMapHighlightView } from '../ui_game_map/UIGameMapHighlightView.ts';
import { UIInvisibleBackgroundView } from './UIInvisibleBackgroundView.ts';
import { UIPlacementConfirmationButton } from './UIPlacementConfirmationButton.ts';
import { UIGameInitialPlacementsConfirmationController } from './UIGameInitialPlacementsConfirmationController.ts';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
import { handleClickWithoutDragging } from '../../ui_utils/GestureUtils.ts';
import { TurnState } from '@colonist/game-states';
export class UIGameConfirmActionController {
    get selectedLocationIndex() {
        return this._selectedLocationIndex;
    }
    setupInvisibleBackground(action) {
        this.removeInvisibleBackground();
        const mapView = this.uiGameManager.mapController.mapView;
        const backgroundClickAction = ()=>{
            this.uiGameManager.mapController.hoverController.onClickInvisibleBackground();
            action();
        };
        this.invisibleBackground = new UIInvisibleBackgroundView(-mapView.worldWidth, -mapView.worldHeight, mapView.worldWidth * 2, mapView.worldHeight * 2, mapView.layers.mapTiles, mapView, backgroundClickAction);
        this.invisibleBackground.drawBg();
        this.handleInvisibleBackgroundCancel();
    }
    handleInvisibleBackgroundCancel() {
        const isUserOnNewMobileApp = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI;
        if (!this.invisibleBackground) return;
        if (!isUserOnNewMobileApp) {
            var _this_invisibleBackground;
            (_this_invisibleBackground = this.invisibleBackground) === null || _this_invisibleBackground === void 0 ? void 0 : _this_invisibleBackground.on('click', ()=>this.removeVisualComponents());
            return;
        }
        handleClickWithoutDragging(this.invisibleBackground, ()=>this.removeVisualComponents());
    }
    showActionConfirmation(highlightParameters, buttonX, buttonY, buttonSize, cancelAction, allowedMechanics, placementIndex) {
        this.removeVisualComponents();
        this.highlightWhite(highlightParameters, cancelAction);
        this.initialPlacementsConfirmationController.highlightNeighborTilesAndPorts(placementIndex);
        this.sendSelectedInitialPlacementIndex(placementIndex);
        const maximumWidthOfButtonAndResources = buttonSize * 1.1;
        let offsetX = -maximumWidthOfButtonAndResources * (allowedMechanics.length - 1) / 2;
        for (const mechanic of allowedMechanics){
            const texture = mechanic.texture;
            const canTakeAction = mechanic.canTakeAction;
            const bankActionAmount = mechanic.bankActionAmount;
            const myColor = this.uiGameManager.gameController.myColor;
            const mechanicButtonX = buttonX + offsetX;
            const buttonAction = ()=>{
                this.cleanupConfirmation();
                mechanic.action(placementIndex);
            };
            const placementButton = new UIPlacementConfirmationButton(mechanicButtonX, buttonY, buttonSize, buttonSize, this.uiGameManager.mapController.mapView, this.uiGameManager, buttonAction, texture, canTakeAction, myColor, bankActionAmount, mechanic.hoverActionController, placementIndex);
            this.placementButtons.push(placementButton);
            this._selectedLocationIndex = highlightParameters.index;
            offsetX += maximumWidthOfButtonAndResources;
            const resourcesToBuild = mechanic.resourcesToBuild;
            placementButton.addResourceCardStates(resourcesToBuild, this.uiGameManager.cardController.getCardInventory());
            placementButton.zIndex = this.uiGameManager.mapController.mapView.layers.informationPopups;
        }
    }
    sendSelectedInitialPlacementIndex(placementIndex) {
        if (this.uiGameManager.gameController.currentState.turnState != TurnState.InitialPlacement) return;
        if (!this.uiGameManager.gameController.isMyTurn) return;
        if (this.selectedInitialPlacementIndex == placementIndex) return;
        this.selectedInitialPlacementIndex = placementIndex;
        this.uiGameManager.socketGameSend.selectedInitialPlacementIndex(placementIndex);
    }
    cleanupConfirmation() {
        this.removeInvisibleBackground();
        this.removeVisualComponents();
    }
    removeVisualComponents() {
        this.removeWhiteHighlight();
        this.removePlacementConfirmButton();
        this.initialPlacementsConfirmationController.removeNeighborTilesAndPortsHighlights();
    }
    highlightWhite(highlightParameters, action) {
        const whiteHighlightContainer = this.uiGameManager.mapController.mapView;
        const whiteHighlightAction = ()=>{
            this.removeVisualComponents();
            action();
        };
        const whiteHighlightView = new UIGameMapHighlightView(this.uiGameManager, highlightParameters, whiteHighlightContainer, whiteHighlightAction, true);
        this.whiteHighlightViews.push(whiteHighlightView);
    }
    removePlacementConfirmButton() {
        this.sendSelectedInitialPlacementIndex(undefined);
        for (const placementButton of this.placementButtons){
            placementButton.destroy();
        }
        this.placementButtons = [];
        this._selectedLocationIndex = undefined;
    }
    removeWhiteHighlight() {
        this.whiteHighlightViews.forEach((whiteHighlightView)=>{
            this.uiGameManager.mapController.mapView.removeChild(whiteHighlightView);
        });
        this.whiteHighlightViews = [];
    }
    removeInvisibleBackground() {
        if (this.invisibleBackground == undefined) return;
        this.invisibleBackground.parent.removeChild(this.invisibleBackground);
        this.invisibleBackground = undefined;
    }
    constructor(uiGameManager){
        this.placementButtons = [];
        this.whiteHighlightViews = [];
        this.uiGameManager = uiGameManager;
        this.initialPlacementsConfirmationController = new UIGameInitialPlacementsConfirmationController(this.uiGameManager);
    }
}
